import { CrearCorteRes } from "src/pages/Cortes/interfaces/CrearCorteRes"
import { RenderSnackbarProps } from "src/shared/hooks/useSnackbar"

export interface HandleRecepcionistaParams {
    withLogout: boolean
    variables: Record<string, any>
    crearCorte: (
        variables: Record<string, any>,
        onSuccess?: (data?: CrearCorteRes) => void,
        onError?: (error?: any) => void,
        onFinally?: () => void
    ) => void
    cambiarTurno: () => void
    setSuccessData: (data: any) => void
    setSuccess: (value: boolean) => void
    onSuccessNewCorte: (params: { folio: string; corte_id: string }) => void
    showSnackbar: (params: RenderSnackbarProps) => void
    setOpenImpresion: (value: boolean) => void
    setisCerrarCorteLoading: (value: boolean) => void
    setdisableButtons: (value: boolean) => void
}

// Recepcionista siempre crea un corte nuevo; nunca se cierra automáticamente
export const handleRecepcionista = ({
    withLogout,
    variables,
    crearCorte,
    cambiarTurno,
    setSuccessData,
    setSuccess,
    onSuccessNewCorte,
    showSnackbar,
    setOpenImpresion,
    setisCerrarCorteLoading,
    setdisableButtons,
}: HandleRecepcionistaParams): void => {
    crearCorte(
        variables,
        (data) => {
            setSuccessData(data)
            if (withLogout) {
                cambiarTurno()
            } else {
                setSuccess(true)
            }
            onSuccessNewCorte({
                folio: String(data?.folio || ""),
                corte_id: data?.corte_id || "",
            })
        },
        (error) => {
            console.log("error, ", error)
            showSnackbar({
                title: "Error al crear corte",
                text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                status: "error",
            })
        },
        () => {
            setOpenImpresion(false)
            setisCerrarCorteLoading(false)
            setdisableButtons(false)
        }
    )
}
